import { type ReactNode } from "react"
import Image from "next/image"

import { CymaticCloud } from "@/app-shell/components/CymaticCloud"
import { Show } from "@clerk/nextjs"

import { SignOutButton } from "@/components/shared/SignOutButton"

interface SignupLayoutProps {
  children: ReactNode
}

export function SignupLayout({ children }: SignupLayoutProps) {
  return (
    <div className="relative h-screen grid grid-cols-1 md:grid-cols-2 overflow-hidden">
      <div className="absolute top-6 left-6 md:top-[80px] md:left-[80px] z-10">
        <Image
          src="/coval-logo-vector.svg"
          alt="Coval"
          width={91}
          height={20}
          priority
          className="dark:brightness-0 dark:invert"
        />
      </div>

      {/* Left: independently scrollable */}
      <div className="bg-background relative overflow-hidden">
        <Show when="signed-in">
          <div className="absolute top-6 right-6 md:top-[80px] md:right-[80px] z-10">
            <SignOutButton className="dark:text-white dark:hover:text-white" />
          </div>
        </Show>
        <div className="h-full overflow-y-auto">
          <div className="min-h-full flex items-center justify-center py-16">
            <div className="w-full max-w-[320px] px-6 md:px-0">{children}</div>
          </div>
        </div>
      </div>

      {/* Right: hidden on mobile */}
      <div className="hidden md:block relative overflow-hidden">
        <CymaticCloud />
      </div>
    </div>
  )
}
